import { Pipe, PipeTransform } from '@angular/core';
import { PhotoGroupList } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { getPhotoGroupIdFromPhotoId } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/helpers';

@Pipe({
    name: 'getPhotoGroupFromPhotoId',
    standalone: false
})
export class GetPhotoGroupFromPhotoIdPipe implements PipeTransform {
  transform(photoId: string, imageRelations: PhotoGroupList[]): string {
    return getPhotoGroupIdFromPhotoId(photoId, imageRelations);
  }
}
